/**
 * TanStack Query hooks for `salesforce-hubspot-crm-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	salesforceHubspotCrmIntegrationQueryKeys,
	type CreateSalesforceHubspotCrmIntegrationBody,
	type ListSalesforceHubspotCrmIntegrationResponse,
	type SalesforceHubspotCrmIntegrationRow,
} from "./api";

export function useSalesforceHubspotCrmIntegrationList(): UseQueryResult<ListSalesforceHubspotCrmIntegrationResponse, Error> {
	return useQuery({
		queryKey: salesforceHubspotCrmIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useSalesforceHubspotCrmIntegrationCreate(): UseMutationResult<SalesforceHubspotCrmIntegrationRow, Error, CreateSalesforceHubspotCrmIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: salesforceHubspotCrmIntegrationQueryKeys.all });
		},
	});
}

export function useSalesforceHubspotCrmIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: salesforceHubspotCrmIntegrationQueryKeys.all });
		},
	});
}
